import type { Constructor, INode, IRenderContext, Rect } from '@ardoq/yfiles';
import { LeafNodeVisual } from './leafNode/LeafNodeVisual';
import { ModernizedNodeStyleBase } from './ModernizedNodeStyleBase';
import {
  buildLeafProps,
  createNodeExportSupportLookup,
  getColor,
} from './leafNode/util';

class ArdoqNodeStyle extends ModernizedNodeStyleBase {
  private readonly nodeExportSupportLookup = createNodeExportSupportLookup(
    (context, node) => this.getLayout(context, node)
  );
  constructor(private shapeTemplateId: string) {
    super();
  }

  protected getLayout(context: IRenderContext, node: INode): Rect {
    const props = buildLeafProps(node, context, {
      shapeTemplateId: this.shapeTemplateId,
    });
    return LeafNodeVisual.getLayout(props);
  }

  protected override lookup(node: INode, type: Constructor): unknown {
    return this.nodeExportSupportLookup(node, type) ?? super.lookup(node, type);
  }

  override createVisual(context: IRenderContext, node: INode) {
    const props = buildLeafProps(node, context, {
      shapeTemplateId:
        this.shapeTemplateId === 'none'
          ? 'predefinedProcess'
          : this.shapeTemplateId,
    });
    const color = getColor(node);
    return new LeafNodeVisual({
      ...props,
      color,
    });
  }
}

export { ArdoqNodeStyle };
